import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { useAuth } from './lib/auth';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { ClientsPage } from './pages/ClientsPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { SettingsPage } from './pages/SettingsPage';
import { SignInPage } from './pages/SignInPage';
import { EnvironmentBadge } from './components/EnvironmentBadge';

export function App() {
  return (
    <>
      <EnvironmentBadge />
      <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
      <Route path="/clients/:clientId" element={<ProtectedRoute><ClientDetailPage /></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute><InvoicesPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function HomeRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenStatus label="Loading" />;
  }
  return isAuthenticated ? <Navigate to="/clients" replace /> : <SignInPage />;
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenStatus label="Loading" />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <AppShell>{children}</AppShell>;
}

function FullScreenStatus({ label }: { label: string }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bone text-ink">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-ink/20 border-t-ink" aria-label={label} />
    </main>
  );
}
